import { render, staticRenderFns } from "./SearchResultSection.vue?vue&type=template&id=04ecb982&scoped=true&"
import script from "./SearchResultSection.vue?vue&type=script&lang=js&"
export * from "./SearchResultSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ecb982",
  null
  
)

export default component.exports